(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/result-no-draws-available-fallback.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/result-no-draws-available-fallback.js');
"use strict";

const _svs$ui = svs.ui,
  Paper = _svs$ui.ReactPaper,
  ReactIcon = _svs$ui.ReactIcon,
  ReactButton = _svs$ui.ReactButton;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const ResultNoDrawsAvailableFallback = () => {
  const history = useHistory();
  return React.createElement(Paper, {
    branding: "sport",
    className: "result-no-draws-available"
  }, React.createElement(ReactIcon, {
    color: "sport-800",
    icon: "nav-results",
    size: 800
  }), React.createElement("p", {
    className: "no-results-available"
  }, "Resultat blir synliga efter omg\xE5ngens spelstopp."), React.createElement(ReactButton, {
    className: "result-link-btn",
    inverted: true,
    onClick: () => {
      history.replace("/".concat(TipsenModuleGameUrl.MY_BETS));
    }
  }, "till mina spel"));
};
setGlobal('svs.components.tipsen.routeResult.ResultNoDrawsAvailableFallback', ResultNoDrawsAvailableFallback);

 })(window);